module.exports = __webpack_public_path__ + "img/bannerBg.d7899e6a.png";